import searchResults from './modules/search/searchResults.vue';
import searchSilder from './modules/search/searchSlider.vue';
import specialistForm from './modules/search/components/specialistForm.vue';

import './util/polyfill';

import Vue from 'Vue';
// import Vuex from 'vuex';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history'
});

function init() {
	var azureSearchSettings = { ...window.azureSearchSettings };

	const elProductsOverview = document.getElementById('vue-products-overview');
	if (elProductsOverview !== null) {
		new Vue({
			el: '#vue-products-overview',
			router,
			render: (h) =>
				h(searchResults, {
					props: {
						azureSearchSettings: azureSearchSettings,
						overviewSettings: {
							ArticleType: elProductsOverview.getAttribute('data-article-type') || 'product',
							IndexName: elProductsOverview.getAttribute('data-index-name') || 'agruniek-articles',
							DefaultFilter: "ArticleType eq 'Product'",
							ColumnNames: 'DocumentGuid,DocumentUrl,DocumentDate,ArticleType,Title,Intro,PhotoUrl,Sector,Theme,SectorLabel',
							FacetNames: ['Sector,count:50', 'Theme,count:50'],
							PlaceholderCount: elProductsOverview.getAttribute('data-placeholders'),
							FilterTitle: elProductsOverview.getAttribute('data-filter-title'),
							FilterReset: elProductsOverview.getAttribute('data-filter-reset'),
							PageSize: elProductsOverview.getAttribute('data-page-size') || 12,
							FilterSectors: elProductsOverview.getAttribute('data-filtername-sectors') || 'Sector',
							FilterThemes: elProductsOverview.getAttribute('data-filtername-themes') || 'Thema'
						},
						pageType: 'defaultSearchResultOverview'
					}
				})
		});
	}



	const elNewsOverview = document.getElementById('vue-news-overview');
	if (elNewsOverview !== null) {
		new Vue({
			el: '#vue-news-overview',
			router,
			render: (h) =>
				h(searchResults, {
					props: {
						azureSearchSettings: azureSearchSettings,
						overviewSettings: {
							ArticleType: elNewsOverview.getAttribute('data-article-type') || 'news',
							IndexName: elNewsOverview.getAttribute('data-index-name') || 'agruniek-articles',
							DefaultFilter: "ArticleType eq 'News'",
							ColumnNames: 'DocumentGuid,DocumentUrl,DocumentDate,ArticleType,Title,Intro,PhotoUrl,Sector,Theme,SectorLabel',
							FacetNames: ['Sector,count:50', 'Theme,count:50'],
							PlaceholderCount: elNewsOverview.getAttribute('data-placeholders'),
							FilterTitle: elNewsOverview.getAttribute('data-filter-title'),
							FilterReset: elNewsOverview.getAttribute('data-filter-reset'),
							PageSize: elNewsOverview.getAttribute('data-page-size') || 12,
							FilterSectors: elNewsOverview.getAttribute('data-filtername-sectors') || 'Sector',
							FilterThemes: elNewsOverview.getAttribute('data-filtername-themes') || 'Thema'
						},
						pageType: 'defaultSearchResultOverview'
					}
				})
		});
	}

	const elKnowledgeOverview = document.getElementById('vue-knowledge-overview');
	if (elKnowledgeOverview !== null) {
		new Vue({
			el: '#vue-knowledge-overview',
			router,
			render: (h) =>
				h(searchResults, {
					props: {
						azureSearchSettings: azureSearchSettings,
						overviewSettings: {
							ArticleType: elKnowledgeOverview.getAttribute('data-article-type') || 'knowledge',
							IndexName: elKnowledgeOverview.getAttribute('data-index-name') || 'agruniek-articles',
							DefaultFilter: "ArticleType eq 'Knowledge'",
							ColumnNames: 'DocumentGuid,DocumentUrl,DocumentDate,ArticleType,Title,Intro,PhotoUrl,Sector,Theme,SectorLabel',
							FacetNames: ['Sector,count:50', 'Theme,count:50'],
							PlaceholderCount: elKnowledgeOverview.getAttribute('data-placeholders'),
							FilterTitle: elKnowledgeOverview.getAttribute('data-filter-title'),
							FilterReset: elKnowledgeOverview.getAttribute('data-filter-reset'),
							PageSize: elKnowledgeOverview.getAttribute('data-page-size') || 12,
							FilterSectors: elKnowledgeOverview.getAttribute('data-filtername-sectors') || 'Sector',
							FilterThemes: elKnowledgeOverview.getAttribute('data-filtername-themes') || 'Thema'
						},
						pageType: 'defaultSearchResultOverview'
					}
				})
		});
	}

	const elSpecialistsOverview = document.getElementById('vue-specialists-overview');
	if (elSpecialistsOverview !== null) {
		new Vue({
			el: '#vue-specialists-overview',
			router,
			render: (h) =>
				h(searchResults, {
					props: {
						azureSearchSettings: azureSearchSettings,
						overviewSettings: {
							IndexName: elSpecialistsOverview.getAttribute('data-index-name') || 'agruniek-specialists',
							ColumnNames: 'DocumentGuid,Sector,Region,FirstName,LastName,Telephone,Email,Function,Gender,PhotoOverviewUrl,PhotoModalUrl,Whatsapp,SpecialistContactEmail',
							FacetNames: ['Sector,count:50'],
							PlaceholderCount: elSpecialistsOverview.getAttribute('data-placeholders'),
							FilterTitle: elSpecialistsOverview.getAttribute('data-filter-title'),
							FilterReset: elSpecialistsOverview.getAttribute('data-filter-reset'),
							Translations: elSpecialistsOverview.getAttribute('data-translations'),
							PageSize: elSpecialistsOverview.getAttribute('data-page-size') || 24,
							FilterSectors: elSpecialistsOverview.getAttribute('data-filtername-sectors') || 'Sector'
						},
						pageType: 'defaultSearchResultOverview'
					}
				})
		});
	}

	const elMoreArticleSlider = document.getElementById('vue-morearticleslider');
	if (elMoreArticleSlider !== null) {
		new Vue({
			el: '#vue-morearticleslider',
			render: (h) =>
				h(searchSilder, {
					props: {
						azureSearchSettings: azureSearchSettings,
						overviewSettings: {
							IndexName: elMoreArticleSlider.getAttribute('data-index-name') || 'agruniek-articles',
							ColumnNames: 'DocumentGuid,DocumentUrl,DocumentDate,ArticleType,Title,Intro,PhotoUrl,Sector,Theme,SectorLabel',
							PageSize: elMoreArticleSlider.getAttribute('data-page-size') || 10,
							SectorList: elMoreArticleSlider.getAttribute('data-sectorlist') || '',
							ExcludedGuid: elMoreArticleSlider.getAttribute('data-excluded-guid') || '',
							OrderBy: elMoreArticleSlider.getAttribute('data-orderby') || null
						}
					}
				})
		});
	}

	const elSpecialistItems = document.querySelectorAll('[data-item="specialistForm"]');
	for (const specialist of elSpecialistItems) {
		new Vue({
			el: specialist,
			render: (h) =>
				h(specialistForm, {
					props: {
						firstName: specialist.getAttribute('data-firstname'),
						fullName: specialist.getAttribute('data-fullname'),
						mail: specialist.getAttribute('data-mail'),
						mailContact: specialist.getAttribute('data-mailcontact'),
						formButtonText: specialist.getAttribute('data-formbuttontext') || 'Verzenden',
						formfieldName: specialist.getAttribute('data-fieldname') || 'Naam',
						formfieldPhoneNumber: specialist.getAttribute('data-fieldphonenumber') || 'Telefoonnummer',
						introTitle: specialist.getAttribute('data-introtitle'),
						introText: specialist.getAttribute('data-introtext'),
						sendTitle: specialist.getAttribute('data-sendtitle'),
						sendText: specialist.getAttribute('data-sendtext'),
					}
				})
		});
	}

	const elExperienceOverview = document.getElementById('vue-experience-overview');
	if (elExperienceOverview !== null) {
		new Vue({
			el: '#vue-experience-overview',
			router,
			render: (h) =>
				h(searchResults, {
					props: {
						azureSearchSettings: azureSearchSettings,
						overviewSettings: {
							IndexName: elExperienceOverview.getAttribute('data-index-name') || 'agruniek-experiences',
							ColumnNames: 'DocumentGuid,DocumentUrl,DocumentDate,Title,Intro,PhotoUrlXL,PhotoUrlLG,PhotoUrlMD,PhotoUrlSM,PhotoUrlXS,AuthorName,Location,Sector',
							FacetNames: ['Sector,count:50'],
							FilterTitle: elExperienceOverview.getAttribute('data-filter-title'),
							FilterReset: elExperienceOverview.getAttribute('data-filter-reset'),
							PageSize: elExperienceOverview.getAttribute('data-page-size') || 3,
							FilterSectors: elExperienceOverview.getAttribute('data-filtername-sectors') || 'Sector',
							PlaceholderCount: elExperienceOverview.getAttribute('data-placeholders'),
						},
						pageType: 'experienceOverview'
					}
				})
		});
	}
}

export default {
	init
};
